// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FvEPI","headingMovedDown":"styles_headingMovedDown__BhNJL","inlineLink":"styles_inlineLink__xMLet"};